/*
* Palo Alto Theme
*
* Use this file to add custom Javascript to Palo Alto.  Keeping your custom
* Javascript in this fill will make it easier to update Palo Alto. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*/


(function() {
  // Custom script to remove decimals from product price

  if (Shopify && Shopify.formatMoney) {
    Shopify.formatMoney = function(cents, format) {
      var value = (cents / 100).toFixed(0); // no decimals
      return format.replace(/\{\{\s*amount[^\}]*\}\}/, value);
    };
  }

  document.addEventListener("DOMContentLoaded", function () {
    console.log("Custom.js script running...");

    setTimeout(function () {
      const priceSpan = document.querySelector('[data-product-price]');
      if (priceSpan) {
        console.log("Found price span:", priceSpan.innerText);
        priceSpan.innerText = priceSpan.innerText.replace('.00', '');
        console.log("Price forced to remove .00");
      } else {
        console.log("Price span not found.");
      }
    }, 500); // Wait 500ms to allow theme JS to render
  });

})();

